<div class="container-fluid " style="background-color: #d0d0d0" >
    <div class="container">
        <div class="row">
            <!-- Login Left -->
            <div class="login-left align-self-center col-md-5">
                <p>Please create your account</p>
                <!-- Form Section -->
                <form (ngSubmit)="login()" [formGroup]="form">


                    <div class="form-group">

                        <input id="fullName" formControlName="fullName" type="text" required class="form-control">
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label for="fullName">Enter your full name</label>
                    </div>


                    <div class="form-group">

                        <input id="EmailAddress" formControlName="email" type="text" required class="form-control">
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label for="EmailAddress">Email Address</label>
                    </div>


                    <div class="form-group">

                        <input id="password" formControlName="password" type="password" required class="form-control">
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label for="password">Password</label>
                    </div>

                    <div class="form-group">

                        <input id="confirmPassword" formControlName="confirmPassword" type="password" required class="form-control">
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label for="confirmPassword">Confirm Password</label>
                    </div>

                    <div class="row justify-content-between checkbox-sec">
                        <div class=" col align-self-start">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="exampleCheck1">
                                <label class="form-check-label" for="exampleCheck1">I agree all statements in <a href="">terms of service</a></label>
                            </div>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-default">Submit</button> <a [routerLink]="['/login']">I’m already a member</a>

                </form>


            </div>

            <div class="login-right col-xl-7 col-sm-6 d-none d-md-block  " style="background-image: url('assets/images/minneapolis-skyline.jpg')">
            </div>   
        </div>
    </div>
</div>
